export default __webpack_public_path__ + "static/media/sbo-title-en.cc016404.webp";